export default "__VITE_ASSET__DfsmRCXe__"